import React from 'react';

interface z7ExtProps {
    width?: number;
    height?: number;
}

export const SevenZExt = ({ height = 26, width = 26 }: z7ExtProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 26 26"
        fill="none"
    >
        <g clipPath="url(#clip0_5885_18349)">
            <path
                d="M23.3269 5.11064L18.4519 0.235638C18.376 0.160337 18.2859 0.100762 18.1869 0.0603282C18.0879 0.0198946 17.9819 -0.000601989 17.875 1.34596e-05H4.875C3.52879 1.34596e-05 2.4375 1.0913 2.4375 2.43751V23.5625C2.4375 24.9087 3.52879 26 4.875 26H21.125C22.4712 26 23.5625 24.9087 23.5625 23.5625V5.68751C23.5631 5.58058 23.5426 5.47458 23.5022 5.37559C23.4618 5.27659 23.4022 5.18656 23.3269 5.11064ZM21.9375 23.5625C21.9375 24.0113 21.5738 24.375 21.125 24.375H4.875C4.42625 24.375 4.0625 24.0113 4.0625 23.5625V2.43751C4.0625 1.98876 4.42625 1.62501 4.875 1.62501H17.0625V4.87501C17.0625 5.77247 17.79 6.50001 18.6875 6.50001H21.9375V23.5625Z"
                fill="#D7D7D7"
            />
            <path
                d="M20 21.1667C20 21.625 19.625 22 19.1667 22H0.833333C0.375 22 0 21.625 0 21.1667V12.8333C0 12.375 0.375 12 0.833333 12H19.1667C19.625 12 20 12.375 20 12.8333V21.1667Z"
                fill="#868181"
            />
            <path
                d="M13.6066 18.9019V19.5H10.8791V18.9019H13.6066ZM13.5211 16.2871L11.1012 19.5H10.6295V18.9976L13.0358 15.8018H13.5211V16.2871ZM13.2204 15.8018V16.3999H10.6671V15.8018H13.2204Z"
                fill="white"
            />
            <path
                d="M10.3148 14.5234V14.9336L8.29822 19.5H7.5155L9.5321 15.1216H6.9071V14.5234H10.3148Z"
                fill="white"
            />
        </g>
        <defs>
            <clipPath id="clip0_5885_18349">
                <rect width="26" height="26" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
